module.exports = __webpack_public_path__ + "static/media/github-1.dc4a71ba.svg";